export const LOADER_DURATION_MS = 3000

export const INITIAL_PEOPLE_COUNT = 12483
export const PEOPLE_COUNT_INTERVAL_MS = 2000

export const QUIZ_LOADING_LABEL = 'onboarding.introAyah.loadingQuiz'

export const QUIZ_LOADING_STAGES = [
  { minProgress: 80, text: 'onboarding.introAyahV2.bismillah' },
  { minProgress: 20, text: 'onboarding.knowledgeQuizIntro.pickingQuestions' },
] as const
